(function(){
    
    // adding custom event listener from maker iframe
    window.onmessage = function(e){
        if(e.data == 'maker:start-free-trial'){
            dispatchCustomEvent({getAttribute: () => 'freeTrialStart'}, {
                links: {
                    linkCategory: 'plans page',
                    linkSection: 'try for free',
                    linkName: 'start free trial',
                    linkType: 'button',
                }
            })
            startFreeTrial()
        }else if(e.data.source == 'maker:additional-plan'){
            const {payload} = e.data;
            dispatchCustomEvent({getAttribute: () => 'linkClick'}, {
                    links: {
                        linkCategory: payload.includes('enterprise') ? 'enterprise plans': payload.includes('agency') ? 'agency plans' : 'team plans',
                        linkSection: window.location.pathname === '/a/content/plans' ? 'plans' : 'plan features',
                        linkName: window.location.pathname === '/a/content/plans' ? 'see plan' : 'see more',
                        linkType: 'button',
                    }
                })
        }
        else if(e.data === 'maker:open-marketo-form'){
            const marketobtn = $('#footer-marketo-cta');
            marketobtn.click();
        }else if(e.data.source === 'maker:subscribe'){
            const {payload} = e.data;
            const urlObj = new URL(payload);
            const searchParam = new URLSearchParams(urlObj.search);
            const nSP = new URLSearchParams(searchParam.get("return_to"));
            const productId = nSP.get("/cart/add?items[0][id]");

            const getProductDetailFromId = id => {
                switch(id){
                    case '43069897670815':
                    case '7910180946074':
                        return {
                            name: 'Create + Pitch',
                            originalPrice: '99.00',
                        }
                    case '44442408648863':
                    case '7910185861274':
                        return {
                            name: 'Create + Deploy',
                            originalPrice: '199.00',
                        }
                    case '41342301012127':
                    case '7118384955546':
                        return {
                            name: 'Web Kit Lite',
                            originalPrice: '2500',
                        }
                    case '39745753383071':
                    case '6722760605850':
                        return {
                            name: 'Web Kit',
                            originalPrice: '7500',
                        }
                    case '39745774616735':
                    case '6722760376474':
                        return {
                            name: 'Standard',
                            originalPrice: '20500',
                        }
                    

                }
            }
            if(productId){
                dispatchCustomEvent({getAttribute: () => 'addToCart'}, {
                    subplan: [{
                        category:'base package',
                        sku: productId,
                        quantity: "1",
                        brand: '',
                        ...getProductDetailFromId(productId)
                    }]
                })
            }     
        }else if(e.data.source === 'maker:speak-to-sales'){
            console.log("speak to sales clicked");
            const {linkSection} = e.data;
            dispatchCustomEvent({getAttribute: () => 'linkClick'}, {
                links: {
                    linkCategory: 'content',
                    linkSection: linkSection,
                    linkName: 'speak to sales',
                    linkType: 'button',
                }
            })
        }else if(e.data.source === 'maker:download-data-sheet'){
            console.log("download data sheet clicked");
            const {linkSection} = e.data;
            dispatchCustomEvent({getAttribute: () => 'linkClick'}, {
                links: {
                    linkCategory: 'content',
                    linkSection: linkSection,
                    linkName: 'download the data sheet',
                    linkType: 'button',
                }
            })
        }
    }
}());

$(document).ready(function(){
    if (currentCompanyData.trialDaysLeft >= 0 || is_trial_expired) {
        // need to send message to hide free trial on maker in this condition.
        const getMakerFrame = () => {
            let iframes = document.querySelectorAll("main iframe");
            return [...iframes].find((iframe) => {
                return iframe.src.includes("app.maker.co");
            });
        };

        for (let i = 0; i < 30; i++) {
            setTimeout(() => {
                const iframe = getMakerFrame();
                // console.log("Sending message to hide free trial", iframe);
                iframe?.contentWindow?.postMessage(
                    "mtf:hide-free-trial",
                    "*"
                );
            }, i * 200);
        }
    }
})